export const REGION_COLORS = [
  { color: "#009FE4", label: "A" },
  { color: "#7D55C7", label: "B" },
  { color: "#FF7F41", label: "C" },
] as const;

export const getRegionColor = (index: number) =>
  REGION_COLORS[index % REGION_COLORS.length];

export function getNextAvailableColor(existingLabels: string[]) {
  const used = new Set(existingLabels);
  for (const entry of REGION_COLORS) {
    if (!used.has(entry.label)) return entry;
  }
  return REGION_COLORS[0];
}

export const MAX_REGIONS = 3;
export const MIN_REGION_SIZE = 1;

export const ZOOM_MIN = 100;
export const ZOOM_MAX = 500;
export const ZOOM_WHEEL_STEP = 0.5;
// true → Ctrl/Cmd + wheel keeps the point under the cursor fixed (zoom-to-cursor);
// false → zoom stays centered. Slider is always centered regardless.
export const ZOOM_TO_CURSOR = true;
